module.exports = __webpack_public_path__ + "img/notify-warning.8148959f.png";